import { useMemo ,useEffect,useState} from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import TemplateIcon from '@untitled-ui/icons-react/build/esm/FileCheck02'; // Import template icon
import FactCheckIcon from '@mui/icons-material/FactCheck'; // renamed
import SmsIcon from '@mui/icons-material/Sms';
import CallIcon from '@mui/icons-material/Call';
import BarChartIcon from '@mui/icons-material/BarChart';
import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';
import CalendarIcon from 'src/icons/untitled-ui/duocolor/calendar';
import { paths } from 'src/paths';
import { useAuth } from 'src/hooks/use-auth';

export const useSections =  () => {
  const [permissions, setPermissions] = useState(false);
  const auth = useAuth();

  useEffect(() => {
    if (!auth.user?.user || !auth.user?.email) {
      setPermissions(false);
      return undefined;
    }

    const controller = new AbortController();
    let active = true;

    const fetchPermissions = async () => {
      try {
        const token = await auth.user.user.getIdToken();
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}api/calender/permissions?email=${auth.user.email}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            },
            signal: controller.signal
          }
        );
        const result = await response.json();
        if (active) {
          setPermissions(result.permissions);
        }
      } catch (error) {
        if (active && error.name !== 'AbortError') {
          setPermissions(false);
        }
      }
    };

    fetchPermissions();

    return () => {
      active = false;
      controller.abort();
    };
  }, [auth.user?.email, auth.user?.user]);

  return useMemo(() => {
    let sections = [
      {
        items: [
          {
            title: 'סקירה כללית',
            path: paths.dashboard.index,
            icon: (
              <SvgIcon fontSize="small">
                <HomeSmileIcon />
              </SvgIcon>
            ),
          },
          {
            title: 'לוח שנה',
            path: paths.dashboard.calendar,
            icon: (
              <SvgIcon fontSize="small">
                <CalendarIcon />
              </SvgIcon>
            ),
          },
          {
            title: 'תבניות שבועיות',
            path: paths.dashboard.templates,
            icon: (
              <SvgIcon fontSize="small">
                <TemplateIcon />
              </SvgIcon>
            ),
          },
          {
            title: 'שיחות',
            path: paths.dashboard.customers.index,
            icon: (
              <SvgIcon fontSize="small">
                <CalendarIcon />
              </SvgIcon>
            ),
          },
          {
            title: 'שיחות פעילות',
            path: paths.dashboard.activeCalls,
            icon: (
              <SvgIcon fontSize="small">
                <CallIcon />
              </SvgIcon>
            ),
          },
          {
            title: 'פעולות משתמשים',
            path: paths.dashboard.activity,
            icon: (
              <SvgIcon fontSize="small">
                <CalendarIcon />
              </SvgIcon>
            ),
          },
          {
            title: 'לוג פעולות ',
            path: paths.dashboard.serviceLogs,
            icon: (
              <SvgIcon fontSize="small">
                <FactCheckIcon />
              </SvgIcon>
            ),
          },
          // הגדרות תתווסף רק אם יש הרשאות
        ],
      }
    ];

    // הוספת הגדרות אם יש הרשאות
    if (permissions) {
      sections[0].items.push({
        title: 'הגדרות',
        path: paths.dashboard.account,
        icon: (
          <SvgIcon fontSize="small">
            <HomeSmileIcon />
          </SvgIcon>
        )
      },
      {
        title: 'רשימת תפוצה בווטצאפ',
        path: paths.dashboard.walist,
        icon: (
          <SvgIcon fontSize="small">
            <CalendarIcon />
          </SvgIcon>
        ),
      },
      {
        title: 'תזכורות SMS',
        path: paths.dashboard.smsReminders,
        icon: (
          <SvgIcon fontSize="small">
            <SmsIcon />
          </SvgIcon>
        ),
      },
      );
    }

    if (permissions) {
      sections.push({
        subheader: 'דוחות',
        items: [
          {
            title: 'סיכום שיחות חודשי',
            path: paths.dashboard.monthlyCallSummary,
            icon: (
              <SvgIcon fontSize="small">
                <BarChartIcon />
              </SvgIcon>
            )
          }
        ]
      });

      sections.push({
        subheader: "בוט טלפוני",
        items: [
          {
        title: 'הוראות לשיחה',
        path: paths.dashboard.botprompt,
        icon: (
          <SvgIcon fontSize="small">
            <HomeSmileIcon />
          </SvgIcon>
        )
      },
      {
        title: 'שיחות',
        path: paths.dashboard.botcalls,
        icon: (
          <SvgIcon fontSize="small">
            <HomeSmileIcon />
          </SvgIcon>
        )
      }
    ]}
      );
    }

    return sections;
  }, [permissions]);
};
